import React, { useEffect } from 'react';
import LandingLayout from '../components/landing/LandingLayout';
import LandingNav from '../components/landing/LandingNav';
import LandingHero from '../components/landing/LandingHero';
import LandingFeatures from '../components/landing/LandingFeatures';
import LandingProductShowcase from '../components/landing/LandingProductShowcase';
import LandingHowItWorks from '../components/landing/LandingHowItWorks';
import LandingCommunity from '../components/landing/LandingCommunity';
import LandingFinalCta from '../components/landing/LandingFinalCta';
import LandingFooter from '../components/landing/LandingFooter';
import { LANDING_TITLE } from '../components/landing/mockups/landingDemoData';

const LandingPage = () => {
  useEffect(() => {
    document.title = LANDING_TITLE;
  }, []);

  return (
    <LandingLayout>
      <div id="top">
        <LandingNav />
        <main>
          <LandingHero />
          <LandingFeatures />
          <LandingProductShowcase />
          <LandingHowItWorks />
          <LandingCommunity />
          <LandingFinalCta />
        </main>
        <LandingFooter />
      </div>
    </LandingLayout>
  );
};

export default LandingPage;
